/**
 *
 * SearchInput
 *
 */

import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Icon } from '@nv/react-commons/src/Components'
import { Input } from '../Input'
import { Colors } from 'themes'
import { faSearch } from '@fa-pro-regular/faSearch'

const StyledInput = styled(Input)`
  line-height: 40px;
  flex-grow: 0;
  flex-shrink: 1;

  > span.ant-input-prefix {
    color: ${Colors.warmGrey};
    left: 15px;
  }

  > input.ant-input {
    background-color: ${Colors.whiteTree};
    border: none;
    border-radius: 5px;
    font-size: 14px !important;
    height: 40px;

    &:not(:first-child) {
      padding-left: 45px;
    }

    &::placeholder {
      color: ${Colors.warmGrey};
    }

    &:focus {
      box-shadow: none;
    }
  }
`

class SearchInput extends React.PureComponent {
  render () {
    return <StyledInput {...this.props} />
  }
}

SearchInput.propTypes = {
  placeholder: PropTypes.string
}

SearchInput.defaultProps = {
  placeholder: 'search_input_placeholder',
  prefix: <Icon icon={faSearch} />
}

export { SearchInput }
